import { computed, Directive, Signal } from '@angular/core';
import { NavItemModel, TargetType } from '@libs/shared/models';
import { LinkDirective } from './link.directive';

@Directive({
  selector: '[uiNavLink]',
})
export class NavLinkDirective extends LinkDirective<NavItemModel> {
  public override readonly target: Signal<TargetType> = computed(() => {
    return this.link().target ?? '_self';
  });

  protected override getRawHref(link: NavItemModel): string | undefined {
    return link.url;
  }
}
